// TextPlusImageCard.js

import React from 'react';
import { useTranslation } from 'react-i18next';

function TextPlusImageCard(props) {

    var { t } = useTranslation();

    if (props.order == "right") {
        return (
            <>
                <section className="uk-section uk-section-default">
                    <div className="uk-container uk-container-medium">
                        <div className="uk-grid-large uk-flex-middle" uk-grid="true">
                            <div className="uk-width-1-2@m">
                                <div className="uk-card uk-card-default uk-card-body uk-box-shadow-medium uk-text-center">
                                    <img
                                        src={props.imageURL}
                                        alt={props.imageAlt}
                                        className="uk-border-rounded uk-margin-bottom"
                                    />
                                    <p>
                                        {props.imageFrameText}
                                    </p>
                                </div>
                            </div>
                            <div className="uk-width-1-2@m">
                                <h2 className="uk-heading-line">
                                    <span>
                                        {props.title}
                                    </span>
                                </h2>
                                <p className="uk-text-lead">
                                    {props.fatText}
                                </p>
                                <p>
                                    {props.thinText}
                                </p>
                                <a href="/apply-visa" className="uk-button uk-button-jai uk-margin-top">
                                    {props.cta}
                                </a>
                            </div>

                            
                        </div>
                    </div>
                </section>
            </>
        );
    }
    else {
        return (
            <>
                <section className="uk-section uk-section-default">
                    <div className="uk-container uk-container-medium">
                        <div className="uk-grid-large uk-flex-middle" uk-grid="true">
                            <div className="uk-width-1-2@m">
                                <h2 className="uk-heading-line">
                                    <span>
                                        {props.title}
                                    </span>
                                </h2>
                                <p className="uk-text-lead">
                                    {props.fatText}
                                </p>
                                <p>
                                    {props.thinText}
                                </p>
                                <a href="/apply-visa" className="uk-button uk-button-jai uk-margin-top">
                                    {props.cta}
                                </a>
                            </div>

                            <div className="uk-width-1-2@m">
                                <div className="uk-card uk-card-default uk-card-body uk-box-shadow-medium uk-text-center">
                                    <img
                                        src={props.imageURL}
                                        alt={props.imageAlt}
                                        className="uk-border-rounded uk-margin-bottom"
                                    />
                                    <p>
                                        {props.imageFrameText}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }

}

export default TextPlusImageCard;